import * as Sentry from '@sentry/react';
import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesDataProsConsGrid } from './ProsConsGrid.proptypes';

import Picture from '../../../../ui/Atoms/Picture';

import { getStaticUrl } from '../../../utils/getStaticUrl';

import * as S from './ProsConsGrid.styles';

export const ProsConsGridSlice = ({ slice }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const {
    pros_cons_grid_slide_id: id,
    cons_title: constTitle,
    pros_title: prosTitle,
    grid_logo: { alt, localFile },
  } = data || '';

  const imageProps = {
    imageObject: getImage(localFile),
    imageUrl: getStaticUrl(localFile?.publicURL),
    altText: alt,
    isNotLazy: false,
  };

  const items = slice.items || '';
  if (items?.length < 2) {
    Sentry.captureMessage('Error: missing required data in ProsConsGrid slice');
    return null;
  }

  const pros = items.filter(item => item.pros_or_cons === 'Pros');
  const cons = items.filter(item => item.pros_or_cons === 'Cons');

  return (
    <S.Wrapper id={id}>
      <S.StyledHead>
        <S.StyledRow>
          <S.StyledContent colSpan={'2'}>
            <S.ImageWrapper>
              <Picture {...imageProps} />
            </S.ImageWrapper>
          </S.StyledContent>
        </S.StyledRow>
        <S.StyledRow>
          <S.StyledTitle>{prosTitle}</S.StyledTitle>
          <S.StyledTitle>{constTitle}</S.StyledTitle>
        </S.StyledRow>
      </S.StyledHead>

      {pros.map((item, index) => (
        <S.StyledRow key={index}>
          <S.StyledContent>
            <S.TextWrapper>
              <S.Icon>{'✅'}</S.Icon>
              <S.Description>{item.description}</S.Description>
            </S.TextWrapper>
          </S.StyledContent>
          <S.StyledContent>
            <S.TextWrapper>
              {cons[index]?.description && <S.Icon>{'❌'}</S.Icon>}
              <S.Description>{cons[index]?.description || ''}</S.Description>
            </S.TextWrapper>
          </S.StyledContent>
        </S.StyledRow>
      ))}
    </S.Wrapper>
  );
};

ProsConsGridSlice.propTypes = {
  /**
   * Content of the ProsConsGrid slice.
   */
  slice: PropTypes.shape(propTypesDataProsConsGrid),
};
